;(function ($, window, document) {
	var $win = $(window)
	var $body = $('body')
	var $doc = $(document)
	var isMobile = null
	var $repositionItem = $('.js-reposition-item')
	var $repositionItemParent = $repositionItem.parent()
	var scrollHeight
	var cachedScrollPos

	var classes = {
		Hover: 'is-hovered',
		Active: 'is-active',
		ShowNav: 'has-nav-opened',
		Fixed: 'is-fixed',
		Visible: 'is-visible',
		Animated: 'is-animated',
		Loaded: 'is-loaded',
		Open: 'is-loaded',
	}

	var get = {
		Scroll: 0,
		WinWidth: 0,
	}

	function window_width() {
		var myWidth = 0
		if (typeof window.innerWidth == 'number') myWidth = window.innerWidth
		else if (document.documentElement && document.documentElement.clientWidth)
			myWidth = document.documentElement.clientWidth
		else if (document.body && document.body.clientWidth) myWidth = document.body.clientWidth
		return myWidth
	}

	function window_height() {
		var myHeight = 0
		if (typeof window.innerHeight == 'number') myHeight = window.innerHeight
		else if (document.documentElement && document.documentElement.clientHeight)
			myHeight = document.documentElement.clientHeight
		else if (document.body && document.body.clientHeight) myHeight = document.body.clientHeight
		return myHeight
	}

	function searchInit() {
		$('.js-search-open').on('click', function (e) {
			e.preventDefault()

			if ($win.width() >= 1024) {
				closeOpenSearch();
			}

			var $searchLink = $(this)
			var $targetSearchBlock = $($searchLink.attr('href'))

			$searchLink.toggleClass('is-active')

			$targetSearchBlock.toggleClass('is-active')

			$('.js-wrapper-inner').toggleClass('is-active')

			if ($win.width() < 1024) {
				cachedScrollPos = $win.scrollTop()

				$('body').addClass('is-fixed')
				$('body').css('top', -cachedScrollPos)
				$('.header').addClass('is-active')
			}
		})

		$('.js-search-field').on('keyup focusout', function () {
			var $this = $(this);

			if ( $this.val() !== "" && $this.val().length >= 3 ) {
				$('.js-search-results').removeClass('hidden')
			} else {
				$('.js-search-results').addClass('hidden')
			}
		})

		$('.js-search-close').on('click', function (e) {
			e.preventDefault()

			$('.search').removeClass('is-active')

			$('.js-search-open').removeClass('is-active')

			$('.js-wrapper-inner').removeClass('is-active')

			$('.js-search-field').each(function(){
				this.value = '';
			});

			$('.header').removeClass('is-active')

			$('body').removeClass('is-fixed')
			$('body').css('top', 'auto')

			if ($win.width() < 1024) {
				window.scrollTo(0, cachedScrollPos)
			}
		})
	}

	function closeOpenSearch() {
		var $openSearch = $('.search__wrapper.is-active');

		if ( $openSearch.length > 0 ) {
			$openSearch.find('.js-search-close').trigger('click').removeClass('is-active');
		}
	}

	$body.on( 'efront_trigger_cart_update', function() {
		$( '.woocommerce-cart-form .table__actions [type="submit"]' ).prop( 'disabled', false ).attr( 'aria-disabled', false ).trigger( 'click' );
	});

	$body.on('adding_to_cart', function() {
		$('main').block({
			message: '<div class="main-block-message"><svg width="38" height="38" xmlns="http://www.w3.org/2000/svg" stroke="#D27F60"><g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd"><circle stroke-opacity=".5" cx="18" cy="18" r="18"/><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/></path></g></svg></div>',
			overlayCSS: {
				background: '#fff',
				opacity: 0.6,
			},
		});
	});

	$body.on('added_to_cart', function() {
		$('main').unblock();
	});

	function navInit() {
		var $nav_primary_li    = $('.js-has-dropdown-primary');
		var $nav_primary_links = $nav_primary_li.children('a');
		var $nav_primary_drop  = $nav_primary_links.siblings('.nav__dropdown');

		$($nav_primary_links, $nav_primary_li, $nav_primary_drop).off('mouseover.navEvents mouseleave.navEvents click.navEvents');

		if ( $win.width() > 1023 ) {
			$('.js-nav-holder').css({
				transform: 'none',
			})

			if ( ! $('html').hasClass('tablet') ) {
				$($nav_primary_li, $nav_primary_drop).on('mouseover.navEvents', function (e) {
					e.preventDefault();

					var $this = $(this);

					if ( $this.hasClass('js-has-dropdown-primary') ) {
						var $dropDownParent = $this;
					} else {
						var $dropDownParent = $this.parents('.js-has-dropdown-primary');
					}

					var $dropdown = $dropDownParent.children('.js-dropdown');
					var $dropdownHeight = $dropdown.outerHeight();

					$dropDownParent.addClass(classes.Active)
					$dropdown.addClass(classes.Active)

					$('.js-dropdown-container').addClass(classes.Open).height($dropdownHeight)

					$('.js-wrapper-inner').addClass(classes.Active)
				})

				$($nav_primary_li, $nav_primary_drop).on('mouseleave.navEvents', function (e) {
					e.preventDefault();

					var $this = $(this);

					if ( $this.hasClass('js-has-dropdown-primary') ) {
						var $dropDownParent = $this;
					} else {
						var $dropDownParent = $this.parents('.js-has-dropdown-primary');
					}

					var $dropdown = $dropDownParent.children('.js-dropdown');
					var $dropdownHeight = $dropdown.outerHeight();

					$dropDownParent.removeClass(classes.Active)
					$dropdown.removeClass(classes.Active)

					setTimeout(function () {}, 200)

					$('.js-dropdown-container').removeClass(classes.Open).css({
						height: '0',
					})

					$('.js-wrapper-inner').removeClass(classes.Active)
				});
			} else {
				$($nav_primary_links, $nav_primary_li).on('click.navEvents', function (e) {
					e.preventDefault();

					var $this = $(this);

					if ( $this.hasClass('js-has-dropdown-primary') ) {
						var $dropDownParent = $this;
					} else {
						var $dropDownParent = $this.parents('.js-has-dropdown-primary');
					}

					if ( $('html').hasClass('tablet') && $dropDownParent.hasClass(classes.Active) ) {
						window.location.href = $dropDownParent.children('a').attr('href');
					}

					var $dropdown = $dropDownParent.children('.js-dropdown');
					var $dropdownHeight = $dropdown.outerHeight();

					$dropDownParent.addClass(classes.Active)
					$dropdown.addClass(classes.Active)

					$('.js-dropdown-container').addClass(classes.Open).height($dropdownHeight)

					$('.js-wrapper-inner').addClass(classes.Active)
				});
			}
		} else {
			$nav_primary_links.on('click.navEvents', function (e) {
				e.preventDefault()

				var $this = $(this);
				var $navHolder = $('.js-nav-holder')
				var navLevel = $this.attr('data-level');
				var $navHolderWidth = $navHolder.outerWidth()

				$this.siblings('.nav__dropdown').removeClass('is-active');

				var $linkDropdownData = $(this).siblings('.nav__dropdown')

				$linkDropdownData.addClass('is-active')

				$('.js-nav-back').addClass('is-active').attr('data-current-level',navLevel);

				$navHolder.css({
					transform: 'translateX(' + -$navHolderWidth * navLevel + 'px)',
				})
			});
		}

		$('.js-nav-back').off('click.mobileNav').on('click.mobileNav', function (e) {
			e.preventDefault()

			var $this         = $(this),
				currentLevel  = parseInt($this.attr('data-current-level')),
				backLevel     = currentLevel > 0 ? currentLevel - 1 : 0,
				newTranslateX = 0;

			if ( backLevel === 0 ) {
				$this.removeClass('is-active');
			} else {
				var $navHolder = $('.js-nav-holder'),
					$navHolderWidth = $navHolder.outerWidth();

				newTranslateX = -$navHolderWidth * backLevel;
			}

			$this.attr('data-current-level', backLevel);

			if ($win.width() > 1023) {
				$('.js-dropdown').removeClass('is-active');
			}

			$('.js-nav-holder').css({
				transform: 'translateX(' + newTranslateX + 'px)',
			});

			$('.js-nav-holder a[data-level="' + currentLevel + '"]').siblings('.nav__dropdown').removeClass('is-active');
		})
	}

	function initIsotope() {
		if ($('.promos__item.isotope')) {
			$('.promos__items').isotope({
				itemSelector: '.promos__item.isotope',
				layoutMode: 'packery',
				packery: {
					gutter: 0,
				},
				percentPosition: true,
			})
		}
	}

	function initializeSliders(selector) {
		if (selector === undefined) {
			selector = '.js-slider'
		}

		var $element = $doc.find(selector)

		if (!$element.length) {
			return false
		}

		$element.each(function () {
			var $slider = $(this)
			var sliderId = $slider.attr('id')
			var $sliderSlides = $slider.find('.slider__slides:not(.slick-initialized)')
			var $sliderArrows = $slider.find('.slider-arrows')
			var $sliderDots = $slider.find('.slider-dots')
			var iframes = $slider.find('.embed-player')

			/* Additional Slider's data attributes to change plugin settings */

			var showSlides = parseInt($slider.attr('data-slidestoshow'))
				? parseInt($slider.attr('data-slidestoshow'))
				: 1
			var showSlidesTablet = parseInt($slider.attr('data-slidestoshow-tablet'))
				? parseInt($slider.attr('data-slidestoshow-tablet'))
				: 1
			var showSlidesMobile = parseInt($slider.attr('data-slidestoshow-mobile'))
				? parseInt($slider.attr('data-slidestoshow-mobile'))
				: 1
			var initialSlide = parseInt($slider.attr('data-initial-slide'))
				? parseInt($slider.attr('data-initial-slide'))
				: 0
			var autoplaySlides = $slider.attr('data-autoplay') == 'true' ? true : false
			var autoplayDelay = $slider.attr('data-autoplay-delay') || 5000
			var autoHeight = $slider.attr('data-autoheight') == 'true' ? true : false
			var loopSlides = $slider.attr('data-loop') == 'false' ? false : true
			var centerSlides = $slider.attr('data-center') == 'true' ? true : false

			var slidesWidth = $slider.attr('data-width') == 'false' ? true : false

			var fadeSlides = $slider.attr('data-fade') == 'true' ? true : false

			/* Plugin Settings */

			var settings = {
				arrows: true,
				appendArrows: $sliderArrows,
				dots: true,
				appendDots: $sliderDots,
				infinite: loopSlides,
				slidesToShow: showSlides,
				adaptiveHeight: autoHeight,
				autoplay: autoplaySlides,
				centerMode: centerSlides,
				autoplaySpeed: autoplayDelay,
				initialSlide: initialSlide,
				speed: 400,
				touchMove: true,
				fade: fadeSlides,
				variableWidth: slidesWidth,
				cssEase: 'linear',
				responsive: [
					{
						breakpoint: 1199,
						settings: {
							slidesToShow: showSlidesTablet,
						},
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: showSlidesMobile,
						},
					},
				],
			}

			if ($slider.hasClass('js-slides-paging')) {
				var currentSlideInfo = $slider.find('.slider-paging li:nth-child(1)')
				var allSlidesInfo = $slider.find('.slider-paging li:nth-child(3)')

				$sliderSlides.on('init', function (event, slick, currentSlide) {
					slickEl = $(slick.currentTarget)

					var allSlidesCount =
						slickEl.slideCount <= 9 ? slickEl.slideCount : slickEl.slideCount

					allSlidesInfo.text(allSlidesCount)
				})

				$sliderSlides.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
					slickEl = $(slick.$slider)

					var currentSlideNum = nextSlide + 1
					var currentSlideNum = nextSlide + 1 <= 9 ? nextSlide + 1 : nextSlide + 1

					currentSlideInfo.text(currentSlideNum)
				})
			}

			$sliderSlides.on('init', function (event, slick, currentSlide) {
				slickEl = $(slick.currentTarget)

				var $currentSlide = $($(slick.$slides).get(currentSlide))

				if ($('.circles').length && $currentSlide) {
					$currentSlide.find('.circles').addClass('is-active')
					setTimeout(function () {
						animateCount($currentSlide)
					}, 2000)
				}

				setTimeout(function () {
					playPauseVideo(slickEl, 'play')
				}, 1000)
			})

			$sliderSlides.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				slickEl = $(slick.$slider)
				$(slick.$slides).each(function (index, el) {
					if ($('.circles').length) {
						$(this).find('.circles').removeClass('is-active')
					}
				})
			})

			$sliderSlides.on('afterChange', function (event, slick, currentSlide) {
				slickEl = $(slick.$slider)
				playPauseVideo(slickEl, 'play')

				var $currentSlide = $($(slick.$slides).get(currentSlide))

				if ($('.circles').length && $currentSlide) {
					$currentSlide.find('.circles').addClass('is-active')
					setTimeout(function () {
						animateCount($currentSlide)
					}, 2000)
				}
			})

			$sliderSlides.slick(settings)

			if ($sliderSlides.find('.slider__slide').length == 1) {
				$sliderSlides
					.not('.js-product-slider')
					.slick('slickSetOption', 'slidesToShow', 1, true)
					.addClass('slider__slide--single')
			}

			if ( $slider.hasClass('js-product-slider') && $sliderDots.length > 0 ) {
				$sliderDots.find('li').off('click.product_slider_dots');

				$sliderDots.find('li').on('click.product_slider_dots', function () {
					var $this = $(this)

					// close other boxes
					// $('.js-box-product').removeClass('is-active')

					// get selected product
					var $slider = $this.closest('.js-product-slider')
					var $current_product = $slider.find('.slick-slide.slick-active .slider__slide')
					var current_product_id = $current_product.attr('data-product-id')

					$select = $slider
						.parent('.product__slider')
						.siblings('.js-box-product')
						.find('.js-select select')
						.val( current_product_id )
						.selectric( 'refresh' );

					$body.trigger( 'efront_product_type_select_change', [ $select ] );
				})
			}

			if ($('[data-slidestoshow-mobile="0"]').length) {
				var $destroySlidesXs = $('[data-slidestoshow-mobile="1"]').find('.slider__slides')

				$(window).on('load resize', function () {
					setTimeout(function () {
						if (
							$(window).outerWidth() < 768 &&
							$destroySlidesXs.hasClass('slick-initialized')
						) {
							$destroySlidesXs.slick('unslick')
						}

						if (
							$(window).outerWidth() >= 768 &&
							!$destroySlidesXs.hasClass('slick-initialized')
						) {
							$destroySlidesXs.slick(settings)
						}
					}, 350)
				})
			}

			// not being used as far as I can tell

			// function postMessageToPlayer(player, command) {
			//     if (player == null || command == null) return;
			//     player.contentWindow.postMessage(JSON.stringify(command), '*');
			// }

			function playPauseVideo(slick, control) {
				var currentSlide, slideType, startTime, player, video

				currentSlide = slick.find('.slick-current')
				player = currentSlide.find('video').get(0)

				if (player != null) {
					if (control === 'play') {
						player.play()
					} else {
						player.pause()
					}
				}
			}

			function resizePlayer(iframes, ratio) {
				if (!iframes[0]) return

				var win = $('.full-wide-slider'),
					width = win.width(),
					playerWidth,
					height = win.height(),
					playerHeight,
					ratio = ratio || 16 / 9

				iframes.each(function () {
					var current = $(this)
					if (width / ratio < height) {
						playerWidth = Math.ceil(height * ratio)
						current
							.width(playerWidth)
							.height(height)
							.css({
								left: (width - playerWidth) / 2,
								top: 0,
							})
					} else {
						playerHeight = Math.ceil(width / ratio)
						current
							.width(width)
							.height(playerHeight)
							.css({
								left: 0,
								top: (height - playerHeight) / 2,
							})
					}
				})
			}
		})
	}

	function addStickyHeader(winST) {
		if ($('.header-holder').length) {
			var ifScrollStarted = winST > $('.header-holder').offset().top
			var navIsOpened = $('.header').hasClass(classes.ShowNav)

			if (navIsOpened) {
				return
			}

			if ($win.width() >= 1024) {
				closeOpenSearch();
			}

			$('.header').toggleClass(classes.Fixed, ifScrollStarted)

			if ($win.width() >= 1024) {
				$('.nav-utilities-alt').find('.js-nav-link-visible').toggleClass(classes.Visible, ifScrollStarted)
			}
		}
	}

	function leftPad(value, length) {
		return ('0'.repeat(length) + value).slice(-length)
	}

	function getPathFromUrl(url) {
		return url.split(/[?#]/)[0]
	}

	function update_add_to_cart_url(product_id, quantity) {
		var $add_to_cart = $('#add-on-' + product_id + ' .single_add_to_cart_button')
		// rewrite url with new qty

		var href = $add_to_cart.attr('href')
		var href_strip = getPathFromUrl(href)
		var query = '?add-to-cart=' + product_id + '&quantity=' + parseInt( quantity )
		var url = href_strip + query

		//replace url
		$add_to_cart.attr('href', url)
	}

	function update_add_to_cart_form(updated_quantity, price) {
		var $input = $('.product-single .product__aside form.cart .quantity input[name="quantity"]');
		// var $price_html = $('.product-single .product__aside form.cart .woocommerce-variation-price bdi');

		var updated_total = ( parseFloat( price ) * parseInt( updated_quantity ) ).toFixed(2);

		$input.val( parseInt( updated_quantity ) );

		// if ( $price_html.length ) {
		// 	$price_html.contents().filter(function() {
		// 		return this.nodeType == 3
		// 	})[0].textContent = updated_total;
		// }
	}

	function update_loop_add_to_cart_form($product_tile, updated_quantity) {
		var $input = $product_tile.find('.product_form .quantity input[name="quantity"]');
		var $add_to_cart_button = $product_tile.find('.product_form .add_to_cart_button[data-quantity]');

		$input.val( parseInt( updated_quantity ) );

		if ( $add_to_cart_button.length ) {
			$add_to_cart_button.attr( 'data-quantity', parseInt( updated_quantity ) );
		}
	}

	function update_add_to_cart_button(product_id, updated_quantity) {
		var $button = $('button[data-product_id="' + product_id + '"]')

		$button.attr('data-quantity', parseInt( updated_quantity ) )
	}

	function update_loop_total_price(product_id, price, updated_quantity) {
		// loop 'quick add' functionality has a total number
		// which needs to be incremented each time the quantity is increased/decreased

		if ($body.find('.section--list-products').length > 0) {
			// find tile

			var product_tile  = $doc.find('#product-tile-' + product_id);
			var updated_total = ( parseFloat( price ) * parseInt( updated_quantity ) ).toFixed(2);

			var $price_html = $doc.find('#product-tile-' + product_id + ' .box-product .woocommerce-Price-amount bdi');

			// Update total (Only update text node and leave currency symbol).
			$price_html.contents().filter(function() {
				return this.nodeType == 3
			})[0].textContent = updated_total;
		}
	}

	function update_single_total_price( $price_html, price, updated_quantity ) {
		var updated_total = ( parseFloat( price ) * parseInt( updated_quantity ) ).toFixed(2);

		if ( $price_html.length ) {
			// Update total (Only update text node and leave currency symbol).
			$price_html.contents().filter(function() {
				return this.nodeType == 3
			})[0].textContent = updated_total;
		}
	}

	function update_woo_quantity($quantity, updated_quantity) {
		// switch qty field based on body tags

		updated_quantity = parseInt( updated_quantity );

		// main product form -- qty fields

		if ($quantity.parents('.product__aside').length > 0) {
			if ($quantity.parents('.product-type-simple').length > 0) {
				//simple product
				var $product_qty_field = $(
					'.single-product .product__aside .quantity .qty'
				)

				$product_qty_field.val(leftPad(updated_quantity, 2));

				var product_id = $quantity.parents('.product').attr('id').replace('product-', '')

				update_add_to_cart_button(product_id, updated_quantity)
			} else if ($quantity.parents('.product-type-yith_bundle').length > 0) {
				var $product_qty_field = $(
					'.single-product .product__aside .product__actions .quantity .qty'
				)

				$price = $('.single-product .product__aside .product__price').attr('data-price');

				// $product_qty_field.val(leftPad(updated_quantity, 2))

				// update form qty input.
				// update_add_to_cart_form(updated_quantity, $price )

				// $price_html = $('.single-product .product__aside .product__price bdi');

				// update_single_total_price( $price_html, $price, updated_quantity )
			} else {
				//variable product
				var $selected = $('.single-product .product__aside .product__select .js-select select').find(
					'option:selected'
				)

				var $product_qty_field = $(
					'.single-product .product__aside .variations_form .quantity .qty'
				)

				// get qty field by what product type is selected
				// add on products have their own field

				if ($selected.attr('data-type') != 'simple') {
					if ($selected.attr('data-type') == 'yith_bundle') {
						$product_qty_field = $(
							'.single-product .product__aside .yith-wcpb-bundle-form .quantity .qty'
						)
					}

					$product_qty_field.val(leftPad(updated_quantity, 2))

					// update form qty input.
					// update_add_to_cart_form(updated_quantity, $selected.attr('data-price') )

					// Update price.
					// update_single_total_price( $() $selected.attr('data-price'), updated_quantity);
				} else {
					// for simple products increment the url - their is not qty field
					var product_id = $selected.val()
					// update link
					update_add_to_cart_url(product_id, updated_quantity)
				}
			}
		} else {
			// related / upsells / module -- qty fields

			if ($quantity.parents('.section--list-products').length > 0) {
				// get product tile object
				var $product_tile = $quantity.closest('.products__item')

				// update quantity based on product type
				if ($product_tile.hasClass('product-type-variable')) {
					var $selected = $product_tile.find('.js-select select option:selected')
					var $product_qty_field = $product_tile.find(
						'.variations_form .quantity .qty'
					)

					// var price = $selected.attr('data-price')
					var product_id = $product_tile.attr('id')

					product_id = product_id.replace('product-tile-', '')

					// update_loop_total_price(product_id, price, updated_quantity)

					$product_qty_field.val(updated_quantity)
				} else if ($product_tile.hasClass('product-type-yith_bundle')) {
					var product_id = $product_tile.attr('id').replace('product-tile-', '');
					// var price = $product_tile.find('.yith-wcpb-add-to-cart-button').attr('data-price');

					// update bundle add to cart form.
					update_loop_add_to_cart_form($product_tile, updated_quantity)

					// update total on tile
					// update_loop_total_price(product_id, price, updated_quantity)
				} else {
					var product_id = $product_tile.find('.add_to_cart_button').attr('data-product_id')
					// var price = $product_tile.find('.add_to_cart_button').attr('data-price')

					// update button
					update_add_to_cart_button(product_id, updated_quantity)

					// update form qty.
					update_loop_add_to_cart_form($product_tile, updated_quantity);

					// update total on tile
					// update_loop_total_price(product_id, price, updated_quantity)
				}
			}
		}
	}

	function addQuantity() {
		$doc.off('click.addQuantity');

		$doc.on('click.addQuantity', '.js-quantity .js-add', function(e) {
			e.preventDefault();

			var $this     = $(this),
				$quantity = $this.closest('.js-quantity'),
				$target   = $quantity.find('.js-quantity-field'),
				quantity  = parseInt($target.val());

			$target.val(leftPad(quantity + 1, 2));

			var updated_quantity = quantity + 1;

			if ( $quantity.parents( '.woocommerce-cart-form' ).length ) {
				$body.trigger( 'efront_trigger_cart_update' );

				return;
			}

			if ( $target.attr('name') !== 'quantity' ) {
				update_woo_quantity($quantity, updated_quantity);
			}

			$body.trigger( 'efront_dynamic_pricing_trigger_price_ajax', [ get_product_add_to_cart_form( $this ) ] );
		})

		$doc.on('click.addQuantity', '.js-quantity .js-remove', function(e) {
			e.preventDefault();

			var $this     = $(this),
				$quantity = $this.closest('.js-quantity'),
				$target   = $quantity.find('.js-quantity-field'),
				quantity  = parseInt($target.val());

			if (quantity > 1) {
				$target.val(leftPad(quantity - 1, 2));

				var updated_quantity = quantity - 1;

				if ( $quantity.parents( '.woocommerce-cart-form' ).length ) {
					$body.trigger( 'efront_trigger_cart_update' );

					return;
				}

				if ( $target.attr('name') !== 'quantity' ) {
					update_woo_quantity($quantity, updated_quantity);
				}

				$body.trigger( 'efront_dynamic_pricing_trigger_price_ajax', [ get_product_add_to_cart_form( $this ) ] );
			}
		})

		$doc.on('focus', '.js-quantity .js-quantity-field', function(e) {
			this.__lastValue = this.value;
		});

		$doc.on('blur', '.js-quantity .js-quantity-field', function(e) {
			var $this     = $(this);
				$quantity = $this.closest('.js-quantity'),
				quantity  = Math.round( $this.val() );

			if ( quantity < 1 ) {
				quantity = 1;
			}

			$this.val( leftPad( quantity, 2 ) );

			if ( ( $this[0].__lastValue * 1 ) === ( quantity * 1 ) ) {
				return;
			}

			if ( $quantity.parents( '.woocommerce-cart-form' ).length ) {
				$body.trigger( 'efront_trigger_cart_update' );

				return;
			}

			if ( $this.attr('name') !== 'quantity' ) {
				update_woo_quantity($quantity, quantity);
			}

			$body.trigger( 'efront_dynamic_pricing_trigger_price_ajax', [ get_product_add_to_cart_form( $this ) ] );
		});

		// $body.on('change', '.product__options .quantity__field.js-quantity-field', function(e) {
		// 	var $this = $(this)
		// 	var qty = parseInt( $this.val() )

		// 	var $product_qty_field = $('.single-product .quantity .qty_wrapper .qty')

		// 	$product_qty_field.val( leftPad( qty, 2 ) )
		// })
	}

	function animateOnScroll() {
		$('.js-animate').each(function (index, element) {
			var $this = $(element)
			var animateStart = $this.attr('data-start')
			var sectionTop = $this.offset().top
			var sectionHeight = $this.outerHeight()
			var scrollBottom = scrollHeight + $win.outerHeight()
			var sectionStartPosition = sectionHeight * animateStart

			if (sectionTop + sectionStartPosition < scrollBottom) {
				$this.addClass('is-animated')
			}
		})
	}

	function initSelect() {
		var $select = $doc.find('.js-select select')
		if (!$select.length) {
			return false
		}

		$select.each(function () {
			if ( $(this).hasClass('select--product-type') ) {
				// If this is the product type select.

				$(this).selectric({
					optionsItemBuilder: function(itemData) {
						var oos_text = $( itemData.element[0] ).attr('data-oos_text');

						return (typeof oos_text !== 'undefined') ? '<span class="text--strike-through">' + itemData.text + '</span>' + oos_text : itemData.text;
					},
					labelBuilder: function(currItem) {
						var oos_text = $( currItem.element[0] ).attr('data-oos_text');

						return (typeof oos_text !== 'undefined') ? '<span class="text--strike-through">' + currItem.text + '</span>' + oos_text : currItem.text;
					},
				}).on('change', function() {
					$(this).addClass('has_changed');
					$body.trigger( 'efront_product_type_select_change', [ $(this) ] );
				});
			} else if ( $(this).parents('.facetwp-facet').length > 0 ) {
				// If this selectric element is for a facet.

				$(this).selectric().on('change', function() {
					FWP.autoload();
				});
			} else {
				// All other selectric elements.

				$(this).selectric();
			}
		})

		$doc.find('.js-select').each(function () {
			var $labelText = $(this).find('label')

			$labelText.insertBefore($(this).find('.selectric .label'))
		})

		$doc.find('.contact__select select').on('change', function () {
			var $this = $(this),
				form_id = $this.val(),
				$target = $('.contact_row_content#' + form_id)

			if ($target.length) {
				$target
					.siblings('.contact_row_content--selected')
					.removeClass('contact_row_content--selected')

				$target.find('.is-animated').removeClass('is-animated')
				$target.find('.slick-initialized').slick('unslick');
				$win.trigger('scroll')

				history.replaceState(
					null,
					'',
					$win[0].location.pathname + '?enquiry-type=' + form_id
				)

				$target.addClass('contact_row_content--selected')

				initializeSliders();
			}
		})
	}

	function productSelect() {
		$body.on('click', '.js-open-overlay', function (e) {
			var $this = $(this)

			e.preventDefault()

			//close all other boxes
			$('.js-box-product').removeClass('is-active')

			$this
				.parents('.product__body')
				.siblings('.js-box-product')
				.addClass('is-active')
				.find('select:not(.has_changed)')
				.trigger('change')
				// .selectric('refresh')
				.parents('.product')
				.addClass('is-active')
		})

		$body.on('click', '.js-box-close', function (e) {
			e.preventDefault()

			$(this)
				.closest('.js-box-product')
				.removeClass('is-active')
				.parents('.product')
				.removeClass('is-active')
		});

		// trigger add_to_cart

		$body.on('click', '.js-cart-open-product', function (e) {
			e.preventDefault()

			var $cartLink = $(this);

			if ( $cartLink[0].hasAttribute('disabled') ) {
				return;
			}

			var product_id = $cartLink.attr('data-product_id')

			var $product_tile = $cartLink.parents('.products__item')

			var $add_to_cart_button = $product_tile.find(
				// '.product_form .add_to_cart_button'
				'.product_form .single_add_to_cart_button, .product_form .add_to_cart_button'
			)

			$add_to_cart_button.trigger('click')
		});
	}

	function widgetDropdown() {
		$('.js-widget-dropdown').not('.is-active').find('.widget__body').hide()

		//Handle the show/hide logic
		$('.js-widget-dropdown').on('click', '.widget__head', function (event) {
			var $widgetBody = $(this).siblings('.widget__body')

			$widgetBody.stop().slideToggle()

			$(this).parents('.js-widget-dropdown').toggleClass('is-active')
		})
	}

	$.fn.equalizeHeight = function () {
		var maxHeight = 0,
			itemHeight

		this.height('')

		for (var i = 0; i < this.length; i++) {
			itemHeight = $(this[i]).height('auto').height()
			if (maxHeight < itemHeight) {
				maxHeight = itemHeight
			}
		}

		return this.height(maxHeight)
	}

	$.fn.equalizeHeightChildren = function () {
		$(this).each(function (i, el) {
			var $this = $(this),
				$children = $this.children(),
				maxHeight = 0,
				itemHeight

			$children.height('')

			for (var i = 0; i < $children.length; i++) {
				itemHeight = $children.eq(i).height('auto').height()
				if (maxHeight < itemHeight) {
					maxHeight = itemHeight
				}
			}

			$children.height(maxHeight)
		})

		return
	}

	function initSliderNav() {
		var initial_slide = $('.js-slider-single-product .slider__slides').attr('data-initial-slide');

		$('.js-slider-single-product .slider__slides').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			appendArrows: '.js-slider-single-product .slider-arrows',
			fade: true,
			dots: true,
			appendDots: '.js-slider-single-product .slider-dots',
			initialSlide: initial_slide !== undefined ? initial_slide : 0,
			//asNavFor: '.js-slider-single-product-nav .slider__slides',
		});

		// using woocommerce gallery images + custom setup

		$body.on('click', '.js-slider-single-product-nav .product__image-nav', function() {
			var $this = $(this);

			$this.siblings().removeClass('is_active');
			$this.addClass('is_active');

			var product_id = $this.attr('data-product-id');

			if (product_id) {
				// update the selectric + form
				var $select = $('.single-product .product__aside .js-select select');

				if ($select.length && $select.val() != product_id) {
					index = $select.find( 'option[value="' + product_id + '"]' ).index();
					$select.prop( 'selectedIndex', index ).selectric( 'refresh' );
					$body.trigger( 'efront_product_type_select_change', [ $select, false ] );
				}
			}

			// update main slider.
			$('.js-slider-single-product .slider__slides').slick('slickGoTo', $this.index());
		});

		$('.js-zoom-image').zoom({
			on: 'click',
			onZoomIn: function () {
				$('.product__image-img').addClass('is-hidden')
			},
			onZoomOut: function () {
				$('.product__image-img').removeClass('is-hidden')
			},
		})

		if ($win.width() < 768) {
			$('.js-zoom-image').trigger('zoom.destroy')
		}
	}

	function addCustomCursor() {
		var cursor = $('#cursor')

		$(document).mousemove(function (e) {
			var target = $(event.target)

			// update position of cursor
			cursor.css('left', e.clientX - 10).css('top', e.clientY - 10)

			var isRemoveCursor = target.is('.js-remove-cursor *')
			var isButton = target.is('.js-add-cursor .slider-dots')

			cursor.removeClass('is-with-default-cursor')

			if (isRemoveCursor || isButton) {
				cursor.removeClass('is-active is-with-action')

				$('.js-add-cursor').addClass('remove-cursor')
			}

			$('.js-add-cursor').removeClass('is-with-default-cursor')
		})

		$(document).on('mousedown', function (e) {
			cursor.addClass('on-mouse-down')
		})

		$(document).on('mouseup', function (e) {
			cursor.removeClass('on-mouse-down')
		})

		$(document).on('click', function (e) {
			cursor.removeClass('is-zoomed')
		})

		$('.js-add-cursor').each(function () {
			var $this = $(this)
			var isWithAction = $this.hasClass('js-cursor-is-with-action')

			$this.removeClass('remove-cursor')

			$this.on('mouseenter mousemove', function (e) {
				cursor.addClass('is-active')

				if (isWithAction) {
					cursor.addClass('is-with-action')
				}
			})

			$this.on('mouseleave', function (e) {
				$this.removeClass('is-with-default-cursor')
				cursor.removeClass('is-active is-with-action')
			})

			$this.on('click', function (e) {
				if (cursor.hasClass('is-zoomed')) {
					cursor.removeClass('is-zoomed')
				} else {
					cursor.addClass('is-zoomed')
				}
			})
		})

		$('.js-remove-cursor').each(function () {
			var $this = $(this)

			$this.on('mouseenter', function (e) {
				cursor.removeClass('is-active is-with-action')
			})

			$this.on('mouseleave', function (e) {
				cursor.removeClass('is-active is-with-action')
			})
		})
	}

	function initTabs() {
		var activeTabClass = 'is-current'

		$('.tabs__nav a').on('click', function (event) {
			event.preventDefault()

			var $tabLink = $(this)
			var $targetTab = $($tabLink.attr('href'))

			$tabLink
				.parent()
				.add($targetTab)
				.addClass(activeTabClass)
				.siblings()
				.removeClass(activeTabClass)
		})
	}

	function initAccordions() {
		var $accordion = $('.js-accordion')
		$('.accordion__section').not('.is-current').find('.accordion__body').hide()

		$accordion.on('click', '.accordion__head', function (event) {
			var $accordionSection = $(this).closest('.accordion__section')
			var $accordionBody = $accordionSection.find('.accordion__body')

			$accordionBody.stop().slideToggle()

			$accordionSection.toggleClass('is-current')
		});

		var hash = window.location.hash.replace('#', '');

		if ( hash.length > 0 ) {
			var $target = $('#faq-' + hash);

			if ( $target.length > 0 ) {
				$('html, body').animate({
					scrollTop: $target.offset().top - $('header').height(),
				}, 500, function() {
					if ( ! $target.find('.accordion__section').hasClass('is-current') ) {
						$target.find('.accordion__head').trigger('click');
					}
				});
			}
		}
	}

	function fixedElementOnScroll() {
		var $fixedElement = $('.js-fixed-on-scroll')
		var additionalSpace = parseFloat( $fixedElement.attr('data-offset') ) || 0
		var $fixedElementChild = $('.js-fixed-element')
		var fixedElementOffsetTop, fixedElementH, fixedElementChildH
		var headerHeight = $('.header__outer').outerHeight()

		if ($fixedElement.length) {
			fixedElementOffsetTop = $fixedElement.offset().top
			fixedElementH = $fixedElement.outerHeight()
			fixedElementChildH = $fixedElementChild.outerHeight()

			var scroll = $(this).scrollTop()

			if (scroll > fixedElementOffsetTop - headerHeight) {
				$fixedElement.addClass('is-fixed')
			} else {
				$fixedElement.removeClass('is-fixed')
			}

			if (
				scroll >
				fixedElementOffsetTop +
					fixedElementH -
					additionalSpace -
					fixedElementChildH -
					headerHeight
			) {
				$fixedElement.addClass('at-bottom')
			} else {
				$fixedElement.removeClass('at-bottom')
			}
		}
	}

	function efrontStickySidebar() {
		var sidebar = $stickySidebar.stickySidebar({
			containerSelector: '.js-fixed-on-scroll',
			innerWrapperSelector: '.js-fixed-on-scroll__inner',
			topSpacing: 64,
			bottomSpacing: 0,
		})

		if ($win.width() < 1024) {
			$stickySidebar.stickySidebar('destroy');
		}
	}

	function stuckButton(winST) {
		if (!$('.js-btn-product-fixed').length) {
			return
		}

		var $this = $('.js-btn-product-fixed')

		var stuckCondition =
			winST + $('.header__outer').outerHeight() >
			$this.closest('.product-single .product__actions').offset().top +
				$this.closest('.product-single .product__actions').outerHeight() -
				$this.outerHeight()

		if (stuckCondition) {
			$('.js-btn-product-inner').addClass('is-active')
		} else {
			$('.js-btn-product-inner').removeClass('is-active')
		}
	}

	function initMap() {
		var mapStyles = [
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [
					{
						color: '#e9e9e9',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'landscape',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 29,
					},
					{
						weight: 0.2,
					},
				],
			},
			{
				featureType: 'road.arterial',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 18,
					},
				],
			},
			{
				featureType: 'road.local',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				featureType: 'poi',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [
					{
						color: '#dedede',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				elementType: 'labels.text.stroke',
				stylers: [
					{
						visibility: 'on',
					},
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				elementType: 'labels.text.fill',
				stylers: [
					{
						saturation: 36,
					},
					{
						color: '#333333',
					},
					{
						lightness: 40,
					},
				],
			},
			{
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f2f2f2',
					},
					{
						lightness: 19,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 17,
					},
					{
						weight: 1.2,
					},
				],
			},
		]

		$('#map').each(function (index, Element) {
			var center = JSON.parse( $(this).attr('data-center') )
			var zoom = parseInt( $(this).attr('data-zoom') )

			var myOptions = {
				zoom: zoom,
				center: center,
				styles: mapStyles,
			}

			var map = new google.maps.Map(Element, myOptions)

			var marker = new google.maps.Marker({
				position: center,
				map: map,
				icon: {
					url: main_theme.template_url + '/assets/dist/images/ico-pin@2x.png',
					scaledSize: new google.maps.Size(48, 76),
				},
			})

			google.maps.event.addDomListener(window, 'resize', function () {
				map.setCenter(center)
			})
		})
	}

	function initMp4Video() {
		var videoHolder = $('.js-video-holder')
		var $videos = $(videoHolder)
		var video = $(videoHolder).find('video').get(0)

		if ($videos.length) {
			$videos.each(function () {
				var $this = $(this)
				var $playBtn = $this.siblings('.js-btn-play')

				$playBtn.on('click', function (event) {
					event.preventDefault()

					$(this).closest('.video-holder').addClass('is-playing')

					video.play()
				})
			})
		}
	}

	function initIframeVideo() {
		$('.video_popup').magnificPopup({
			type: 'iframe',
			iframe: {
				markup:
					'<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close"></div>' +
					'<iframe class="mfp-iframe" src="//about:blank" frameborder="0" allow="autoplay" allowfullscreen></iframe>' +
					'</div>',
				patterns: {
					youtube: {
						index: 'youtube.com/',
						id: 'v=',
						src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0',
					},
					youtube_short: {
						index: 'youtu.be/',
						id: 'youtu.be/',
						src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
					},
					vimeo: {
						index: 'vimeo.com/',
						id: '/',
						src: '//player.vimeo.com/video/%id%?autoplay=1',
					},
				},
				srcAction: 'iframe_src',
			},
		})
	}

	function videoPopup() {
		$('.js-video-popup').magnificPopup({
			disableOn: 700,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,

			fixedContentPos: false,
		})
	}

	function isInViewport() {
		if ($('.js-circles').length) {
			var topElement = $('.js-circles').offset().top
			var bottomElement = $('.js-circles').offset().top + $('.js-circles').outerHeight()
			var bottomScreen = $win.scrollTop() + $win.innerHeight()
			var topScreen = $win.scrollTop()

			if (bottomScreen > topElement && topScreen < bottomElement) {
				$('.js-circles').addClass('is-active')
				setTimeout(function () {
					animateCount($('.js-circles'))
				}, 2000)
			}
		}
	}

	function animateCount($currentSlide) {
		var countChilds = $currentSlide.find('.js-count-number')

		countChilds.each(function () {
			var endCount = $(this).attr('data-count-end')

			var startCount = $(this).attr('data-count-start')

			if (!isNaN(endCount) && !isNaN(startCount)) {
				$(this)
					.prop('Counter', startCount)
					.animate(
						{
							Counter: endCount,
						},
						{
							duration: 3000,
							easing: 'swing',
							step: function (now) {
								var incStep = Math.ceil(now)
								$(this).text(incStep.toLocaleString('en'))
							},
						}
					)
			}
		})
	}

	function stickyEl($el, startPosition, isAnchoredOnTop) {
		if ($el.length) {
			isAnchoredOnTop = isAnchoredOnTop == false ? isAnchoredOnTop : true

			$el.toggleClass('is-fixed', $win.scrollTop() > startPosition)
		}
	}

	function repositionItem($item) {
		var target = $item.attr('data-target')
		var position = $item.attr('data-position')
		var $parent = $item.parent()

		if ($item.attr('data-position')) {
			if (position === 'bottom') {
				$item.appendTo($(target))
			} else {
				$item.prependTo($(target))
			}
		}
	}

	function mobileLayout() {
		if ($win.width() < 1024) {
			if (isMobile) {
				return
			}

			isMobile = true

			$repositionItem.each(function () {
				repositionItem($(this))
			})

			if ( $('html').hasClass('ios') ) {
				document.documentElement.style.setProperty('--vh', window_height() + 'px')
			}
		} else {
			if (isMobile === false) {
				return
			}

			$repositionItem.prependTo($repositionItemParent)

			isMobile = false
		}
	}

	function addSlidersArticlesOffset() {
		$('.js-slider-flickity').each(function () {
			var $slider = $(this)

			if ($(window).outerWidth() > 767) {
				if ($slider.find('.article-blog').length) {
					var $firstArticle = $slider.find('.article-blog')
					var $articleImage = $slider.find('.article--image')
					var contentHeight = $firstArticle.find('.article__content').outerHeight()

					setTimeout(function () {
						$firstArticle.each(function () {
							$(this).css({ paddingTop: '0px' })
						})
					}, 60)
				}
			}
		})
	}

	function matchHeightInit() {
		$('.promos__items .promo__match').matchHeight({
			byRow: true,
			property: 'height',
			target: null,
			remove: false,
		})

		$('.news').matchHeight({
			byRow: true,
			property: 'height',
			target: null,
			remove: false,
		})

		$('.products__item .product__head').matchHeight({
			byRow: true,
			property: 'height',
			target: null,
			remove: false,
		})

		$('.review').matchHeight({
			byRow: true,
			property: 'height',
			target: null,
			remove: false,
		})
	}

	function initializeFlickitySliders() {
		var $element = $('.js-slider-flickity')

		if (!$element.length) {
			return false
		}

		$element.each(function () {
			var $slider = $(this)
			var $sliderSlides = $slider.find('.main-carousel')

			// Plugin options

			$sliderSlides.flickity({
				cellAlign: 'left',
				contain: true,
				pageDots: false,
				prevNextButtons: true,
				groupCells: false,
				freeScroll: true,
			})

			addSlidersArticlesOffset()
		})
	}

	function reset_form_variations($form) {
		$form.find('.variations select').each(function (e) {
			var $select = $(this)
			$select.find('option:first').prop('selected', true).trigger('change')
		})
	}

	function move_woo_flexslider_position() {
		var $flex_nav = $('.flex-control-nav.flex-control-thumbs').appendTo('.thumbnail_container')
	}

	function is_child_of_product_tile( $element ) {
		return $element.parents( '.product-tile' ).length > 0;
	}

	function is_child_of_single_product_info( $element ) {
		return $element.parents( '.product__aside' ).length > 0;
	}

	function get_product_parent_wrapper( $element ) {
		if ( is_child_of_single_product_info( $element ) ) {
			return $element.closest( '.product-single' );
		} else if ( is_child_of_product_tile( $element ) ) {
			return $element.closest( '.product-tile' );
		} else {
			return false;
		}
	}

	function get_product_add_to_cart_form( $element ) {
		var $product_parent = get_product_parent_wrapper( $element );

		return $product_parent.find('form.cart');
	}

	function get_custom_product_type_select( $product_parent ) {
		return $product_parent.find( '.select--product-type' );
	}

	$body.on( 'efront_product_type_select_change', function( e, $select, $update_slider = true ) {
		var $product_parent   = get_product_parent_wrapper( $select );
		var $add_to_cart_form = $product_parent.find( 'form.cart' );

		if ( ! $product_parent.length || ! $add_to_cart_form.length ) {
			console.log( 'Unable to find product parent wrapper or product form.' );
			return;
		}

		if ( $update_slider ) {
			$body.trigger( 'efront_update_product_image_slider', [ $select, $product_parent ] );
		}

		$body.trigger( 'efront_update_add_to_cart_form_attr', [ $select, $add_to_cart_form ] );
	});

	$body.on( 'efront_update_loop_add_to_cart_oos', function( e, $product_parent, purchasable ) {
		var $type_select     = get_custom_product_type_select( $product_parent );
		var $selected_option = $type_select.find('option:selected');

		if ( $selected_option.length && $product_parent.length ) {
			if ( purchasable ) {
				$product_parent.find('.box__actions .box__btn').removeAttr( 'disabled' );
			} else {
				$product_parent.find('.box__actions .box__btn').attr( 'disabled', 'true' );
			}
		}
	});

	$body.on( 'efront_update_product_image_slider', function( e, $select, $product_parent ) {
		var variation_id = $select.val();

		// Full size product slider.
		var $product_slider = $product_parent.find( '.slider-product .slider__slides, .slider-product-single .slider__slides');

		if ( $product_slider.length ) {
			var $new_slide = $product_slider.find( '.slider__slide[data-product-id="' + variation_id + '"]').closest( '.slick-slide:not(.slick-active)');

			if ( $new_slide.length ) {
				var new_slide_index = $new_slide.attr( 'data-slick-index' );

				$product_slider.slick( 'slickGoTo', new_slide_index );
			}
		}

		// Thumbnail product images.
		var $thumb_images = $product_parent.find( '.slider-product-single-nav' );

		if ( $thumb_images.length ) {
			var $new_thumb_image = $thumb_images.find( '.product__image-nav[data-product-id="' + variation_id + '"]' ).eq(0);
			
			if ( $new_thumb_image.length ) {
				$thumb_images.find('.is_active').removeClass( 'is_active' );

				$new_thumb_image.addClass( 'is_active' )
			}
		}
	});

	$body.on( 'show_variation', 'form.variations_form', function( e, variation, purchasable ) {
		var $variation_form = $(e.currentTarget);
		var $product_parent = get_product_parent_wrapper( $variation_form );

		if ( is_child_of_product_tile( $variation_form ) ) {
			$body.trigger( 'efront_update_loop_add_to_cart_oos', [ $product_parent, purchasable ] );
		}

		$body.trigger( 'efront_dynamic_pricing_trigger_price_ajax', [ $variation_form ] );
	});

	$body.on( 'efront_update_add_to_cart_form_attr', function( e, $select, $add_to_cart_form ) {
		var was_updated      = false;
		var $selected_option = $select.find('option:selected');
		var $variation_form  = $add_to_cart_form.closest( '.variations_form' );

		reset_form_variations( $variation_form );

		if ( $selected_option.length && $variation_form.length ) {
			var variation_id  = $selected_option.attr( 'value' );
			var selected_data = JSON.parse( $selected_option.attr('data-attribute_value') );
			var $attributes   = $variation_form.find( 'select[name^=attribute]' );

			// Set the hidden variation ID input.
			$variation_form.find( '.single_variation_wrap input[name="variation_id"]' ).val( variation_id );

			// Fall back to radio input elements.
			if ( ! $attributes.length ) {
				$attributes = $variation_form.find( '[name^=attribute]:checked' );
			}

			// Fallback to generic input elements.
			if ( ! $attributes.length ) {
				$attributes = $variation_form.find( 'input[name^=attribute]' );
			}

			$attributes.each( function() {
				var $attr     = $( this );
				var attr_name = $attr.attr( 'name' );
				var attr_val  = $attr.val();

				if ( typeof selected_data[ attr_name ] !== 'undefined' ) {
					var new_val = selected_data[ attr_name ];

					if ( attr_val !== new_val ) {
						$attr.val( selected_data[ attr_name ] );
						$attr.trigger('change');

						was_updated = true;
					}
				}
			});
		}

		return was_updated;
	});

	function update_product_image_in_loop( variation_id ) {
		// select image with matching data

		var $selected_image = $('#product_' +  variation_id  + '.slider__slide')
		var $slider = $selected_image.closest('.slider__slides')
		var $slide = $selected_image.closest('div.slick-slide')

		// some variations may only have one slide
		if ($slide) {
			var slide_num = $slide.attr('data-slick-index')
			$slider.slick('slickGoTo', slide_num)
		}
	}

	// Accordian on product single pages
	function product_info_accordian() {
		// Slide Up all accordians on load
		if ($win.width() < 768) {
			$('.tab__head').each(function () {
				$(this).siblings('div').slideUp()
			})
		}

		// Toggle Accordians Open
		$('.tab__head').on('click', function () {
			if ($win.width() < 768) {
				if ($(this).hasClass('open')) {
					$(this).toggleClass('open')
					$(this).siblings('div').slideToggle()
				} else {
					$('.tab__head').each(function () {
						$(this).siblings('div').slideUp()
						$(this).removeClass('open')
					})

					$(this).toggleClass('open')
					$(this).siblings('div').slideToggle()
				}
			}
		})
	}

	$('.js-open-sidebar').on('click', function (e) {
		e.preventDefault()
		$('.js-sidebar-product').addClass('is-active')
		$('.js-wrapper-inner').addClass('is-active')
		cachedScrollPos = $win.scrollTop()
		$('body').addClass('is-fixed')
		$('body').css('top', -cachedScrollPos)
	})

	$('.js-sidebar-close').on('click', function (e) {
		e.preventDefault()
		$('.js-sidebar-product').removeClass('is-active')
		$('.js-wrapper-inner').removeClass('is-active')
		$('body').removeClass('is-fixed')
		$('body').css('top', 'auto')
		window.scrollTo(0, cachedScrollPos)
	})

	$('.nav-trigger').on('click', function (e) {
		e.preventDefault()
		$('.js-nav').addClass('is-active')
		$('.header').addClass('is-active')
		$('.js-wrapper-inner').addClass('is-active')
		cachedScrollPos = $win.scrollTop()
		$('body').addClass('is-fixed')
		$('body').css('top', -cachedScrollPos)

		if ($win.width() < 1024 && cachedScrollPos === 0) {
			if ($('.bar-alt').length && $('.bar').length) {
				$('.js-nav').css({
					top: $('.bar-alt').outerHeight() + $('.bar').outerHeight(),
				})
			}
		} else {
			$('.js-nav').css({
				top: '0',
			})
		}
	})

	$('.nav_x').on('click', function (e) {
		e.preventDefault()
		$('.nav__dropdown').css('pointer-events', 'none')
		$('.js-has-dropdown-primary').removeClass('is-active')
		$('.js-dropdown').removeClass('is-active')

		setTimeout(function () {}, 200)
		$('.js-dropdown-container').removeClass('is-open').css({
			height: '0',
		})
		$('.js-wrapper-inner').removeClass('is-active')

		setTimeout(function () {
			$('.nav__dropdown').css('pointer-events', 'all')
		}, 1200)
	})

	$('.nav-trigger-close').on('click', function (e) {
		e.preventDefault()
		$('.js-nav').removeClass('is-active')
		$('.header').removeClass('is-active')
		$('.js-wrapper-inner').removeClass('is-active')
		$('body').removeClass('is-fixed')
		$('body').css('top', 'auto')
		window.scrollTo(0, cachedScrollPos)
	})

	$('.nav__dropdown-close').on('click', function (e) {
		e.preventDefault()
		$('.js-nav-dropdown').removeClass('is-active')
		$('.js-wrapper-inner').removeClass('is-active')
		$('.header').removeClass('is-active')
		$('body').removeClass('is-fixed')
		$('body').css('top', 'auto')
		window.scrollTo(0, cachedScrollPos)
	})

	function closeNav() {
		$('.nav_x').trigger('click');
		$('.nav-trigger-close').trigger('click');

		// Reset mobile nav level
		$('.nav-dropdown-back').attr('data-current-level', 0).removeClass('is-active');
		$('.js-nav-holder .nav__dropdown.is-active').removeClass('is-active');
	}

	$('body.woocommerce-page .wrapper .bar a.bar__close').on('click', function () {
		$('body.woocommerce-page .wrapper .bar').slideUp()
	})

	// Hook up fixed single product page add to cart button on mobile to the relevant add to cart button.
	$('.js-fixed-add-to-cart-button').on('click', function (e) {
		e.preventDefault()
		var $this = $(this),
			$prod_aside = $this.parents('.product-single').find('.product__aside')

		if ($prod_aside.find('.add_on_wrapper--show .single_add_to_cart_button').length) {
			$add_to_cart_btn = $prod_aside.find('.add_on_wrapper--show .single_add_to_cart_button')
		} else {
			$add_to_cart_btn = $prod_aside.find('form.cart .single_add_to_cart_button')
		}

		$add_to_cart_btn.trigger('click');
	})

	$win.on('orientationchange', function () {
		closeNav();
	});

	var $stickySidebar = $('.js-fixed-element');

	$win.on('load', function () {
		initializeSliders()
		initSliderNav()

		if ( !$('body').hasClass('woocommerce-order-received') ) {
			initMap();
		}

		initializeFlickitySliders()
		initIsotope()

		// reset sticky sidebar if loaded incorrectly
		// happens when page is reloaded halfway down
		if ( $stickySidebar.length ) {
			$stickySidebar.stickySidebar('updateSticky');
		}

		product_info_accordian()
	})

	$win.on('load resize', function () {
		navInit()
		
		if ( $stickySidebar.length ) {
			efrontStickySidebar();
		}

		setTimeout(function () {
			$('.js-equal-height').equalizeHeight()
		}, 200)
		$('.service-product').equalizeHeight()

		$('.section__groups--promo .products__item').equalizeHeight()

		$('.js-contact-info-cols').equalizeHeightChildren()

		if ($win.width() > 768) {
			$('.product .product__entry').equalizeHeight()
		}

		$('.nav-utilities .has-dropdown').on('mouseover', function () {
			$('.js-wrapper-inner').addClass('is-active')
		})

		$('.nav-utilities .has-dropdown').on('mouseleave', function () {
			$('.js-wrapper-inner').removeClass('is-active')
		})

		if ($win.width() >= 1024) {
			$('.js-has-dropdown').on('mouseover', function () {
				$('.js-wrapper-inner').addClass('is-active')
			})

			$('.js-has-dropdown').on('mouseleave', function () {
				$('.js-wrapper-inner').removeClass('is-active')
			})
		} else {
			$('.js-has-dropdown > a').on('click', function (e) {
				e.preventDefault()
				$('.js-nav-dropdown').addClass('is-active')
				$('.header').addClass('is-active')
				$('.js-wrapper-inner').addClass('is-active')
				cachedScrollPos = $win.scrollTop()
				$('body').addClass('is-fixed')
				$('body').css('top', -cachedScrollPos)

				if (cachedScrollPos === 0 && $('.bar-alt').length && $('.bar').length) {
					$('.js-nav-dropdown').css({
						top: $('.bar-alt').outerHeight() + $('.bar').outerHeight(),
					})
				} else {
					$('.js-nav-dropdown').css({
						top: '0',
					})
				}
			})
		}

		mobileLayout()
	})

	$win.on('load scroll resize', function () {
		get.Scroll = $win.scrollTop()

		addStickyHeader(get.Scroll)
		stuckButton(get.Scroll)

		var $sticky = $('.js-sticky')
		var $bar = $('.js-bar')
		var $barHeight = $('.js-bar').outerHeight()
		var $sectionNav = $('.js-bar-holder')

		if ($bar.attr('data-sticky') === 'true' && $win.width() < 1024) {
			if ($bar.length) {
				var startPosition =
					$sectionNav.offset().top - $('.header .header__inner').outerHeight()

				stickyEl($bar, startPosition, false)
			}
		} else {
			$bar.removeClass('is-fixed')
		}
	})

	$win.on('load scroll', function () {
		scrollHeight = $win.scrollTop()

		animateOnScroll()
		isInViewport()

		if ($win.width() < 768) {
			var elementTop = $('.footer').offset().top
			var elementBottom = elementTop + $('.footer').outerHeight()
			var viewportTop = $(window).scrollTop()
			var viewportBottom = viewportTop + $(window).height()
			if (elementBottom > viewportTop && elementTop < viewportBottom) {
				$('.js-cart-btn-sticky').removeClass('btn--mobile-sticky')
			} else {
				$('.js-cart-btn-sticky').addClass('btn--mobile-sticky')
			}
		}
	})

	$win.on('scroll', function () {
		$('.js-add-cursor').addClass('is-with-default-cursor')

		$('#cursor').removeClass('is-active is-with-action on-mouse-down')
	})

	$doc.on('ready', function () {
		searchInit()

		addQuantity();

		// if this is and archive page these functions
		// are added on facet-load. We don't need to add twice
		if (!$body.hasClass('archive')) {
			initSelect()
			productSelect()
		}

		widgetDropdown()
		addCustomCursor()
		initTabs()
		initAccordions()
		initMp4Video()
		initIframeVideo()
		videoPopup()
		matchHeightInit()

		move_woo_flexslider_position()

		$('.js-responsive-table table tr').each(function () {
			var $tr = $(this)
			var $th = $tr.closest('table').find('th')

			$tr.find('td').each(function (i) {
				$(this).attr('data-title', $th.eq(i).text())
			})
		})
	})

	function switch_variation_by_product_type(pack_type) {
		// get all product tiles

		pack_type = typeof pack_type === 'object' ? pack_type[0] : pack_type;

		$doc.find('.products__item').each(function() {
			var $this = $(this)
			var $select = $this.find('.js-select select')

			var $options = $select.find('option')

			// loop through options to find first that matches pack type
			$options.each(function() {
				var $option = $(this)

				var data = JSON.parse( $option.attr('data-attribute_value') );

				$.each(data, function( index, attr_value ) {
					// switch dropdown options based on pack type
					if (index == 'attribute_pa_pack-type' && attr_value == pack_type) {
						$select.val( $option.val() );
					}
				})
			})
		})

		// loop through attribute_values to find pack type
	}

	function refresh_product_tile_variable_form() {
		$doc.find('.products__item .product_form form.variations_form').each(function() {
			$(this).wc_variation_form();
		});
	}

	$(document).on('facetwp-refresh', function() {
        $('.js-wrapper-inner').addClass('is-facet-loading');
    });

	$(document).on('facetwp-loaded', function () {
		initializeSliders()

		if (FWP.loaded) {
			$('html, body').animate(
				{
					scrollTop:
						$('.section--list-products, .section-articles').parent().offset().top - $('header').height(),
				},
				500
			)
		}

		$('.js-wrapper-inner').removeClass('is-facet-loading');

		$.each(FWP.settings.num_choices, function(key, val) {
			var $parent = $('.facetwp-facet-' + key).closest('.widget--dropdown');
			(0 === val) ? $parent.hide() : $parent.show();
		});

		// switch product image by pack type
		// var pack_type = FWP.facets['pack_type']
		// switch_variation_by_product_type(pack_type)

		refresh_product_tile_variable_form();

		// each time facetWP filters the page - these functions
		// need to applied to the new content

		matchHeightInit()
		initSelect()
		productSelect()
	})

	$doc.on('click', function (e) {
		if (
			!$(e.target).hasClass('js-search-open') &&
			$(e.target).parents('.search').length === 0 &&
			$(e.target).parents('.js-search-open').length === 0 &&
			!$(e.target).hasClass('search') &&
			!$(e.target).hasClass('js-cart-open') &&
			!$(e.target).hasClass('js-cart-open-product') &&
			!$(e.target).hasClass('add_to_cart_button') &&
			!$(e.target).hasClass('single_add_to_cart_button') &&
			!$(e.target).hasClass('js-fixed-add-to-cart-button') &&
			$(e.target).parents('.js-fixed-add-to-cart-button').length === 0 &&
			$(e.target).parents('.cart-header').length === 0 &&
			!$(e.target).hasClass('cart-header') &&
			!$(e.target).hasClass('nav-trigger') &&
			$(e.target).parents('.js-nav').length === 0 &&
			!$(e.target).hasClass('js-nav') &&
			!$(e.target).hasClass('js-has-dropdown') &&
			$(e.target).parents('.nav-utilities-alt').length === 0 &&
			!$(e.target).hasClass('js-open-sidebar') &&
			$(e.target).parents('.js-sidebar-product').length === 0 &&
			$('.js-wrapper-inner').hasClass('is-active')
		) {
			$('.search').removeClass('is-active')
			$('.js-search-open').removeClass('is-active')
			$('.js-wrapper-inner').removeClass('is-active')
			$('.js-box-product').removeClass('is-active')
			$('.cart-header').removeClass('is-active')
			$('.js-cart-open').removeClass('is-active')
			$('.js-wrapper-inner').removeClass('is-active')
			$('.js-nav').removeClass('is-active')
			$('.js-nav').removeClass('is-active')
			$('.js-nav-dropdown').removeClass('is-active')
			$('.js-sidebar-product').removeClass('is-active')
			$('.header').removeClass('is-active')
			$('body').removeClass('is-fixed')
			$('body').css('top', 'auto')
			// window.scrollTo(0, cachedScrollPos);
		}
	})

	$('.js-popup').on('click', function (event) {
		event.preventDefault()

		$($(this).attr('href')).toggleClass('is-visible')
	})

	$(document).on('wc_cart_button_updated', function( e, $button ) {
		$button.next( '.added_to_cart.wc-forward' ).hide();
	});
})(jQuery, window, document)
